<template>
	<div class="s-above">
		<h1 style="margin-bottom:0;" >{{org.name}}</h1>
		<InPageNav
			:options="[
						{
							text : 'Overview',
							path : '/orgs/'+org.id,
						},
						{
							text : 'Team',
							path : '/orgs/'+org.id+'/team',
						},
						{
							text : 'Settings',
							path : '/orgs/'+org.id+'/settings',
						},
						{
							text : 'Billing',
							path : '/orgs/'+org.id+'/billing',
						},
					]"
		/>
	</div>
</template>

<script>

	import InPageNav from "../components/InPageNav.vue";

	export default {
		props : [
			'org',
		],
		components : {
			InPageNav,
		},
	}

</script>